<template>
    <TemplateDefault>
        <template v-if="entry">
            <BaseHero
                :hero-link="entry.heroLink"
                :hero-event="entry.heroEvent[0]"
                :image="entry.heroImages[0]"
            />

            <QueryEventBundle
                v-if="loggedIn"
                :lazy="true"
                :query="{
                    __typename: '[custom]event_bundle_user_saved',
                    preset: 'user-saved'
                }"
            >
                <template #default="{ events }">
                    <BaseSection
                        v-if="events && events.length > 0"
                        width="bleed"
                    >
                        <template #title>
                            Mijn lijst
                        </template>

                        <template #default>
                            <EventSlider
                                :events="events"
                                card-size="large"
                            />
                        </template>
                    </BaseSection>
                </template>
            </QueryEventBundle>

            <FlexibleSections
                v-if="entry.flexibleSections"
                :sections="entry.flexibleSections"
            />
        </template>
    </TemplateDefault>
</template>

<script setup lang="ts">
import HomeQuery from '~/graphql/queries/Home.graphql';
import type { HomeEntryTypeFragment } from '~/types/craft-schema';
import { useEventFiltersStore } from '~/stores/eventFilters';

const eventFiltersStore = useEventFiltersStore();

const { loggedIn } = storeToRefs(useUserStore());

const response = await useAsyncQuery({
    query: HomeQuery
});

const entry = useCraftEntry<HomeEntryTypeFragment>(response);

onBeforeMount(() => {
    eventFiltersStore.filtersVisible = false;
});
</script>

